import { useNavigate } from 'react-router-dom';
import { categories } from '@/mocks/anime';

export default function CategoryNav() {
  const navigate = useNavigate();

  const handleClick = (slug: string) => {
    navigate(`/category/${slug}`);
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  return (
    <section className="py-14 md:py-20 bg-background-100">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950">
            动漫分类
          </h2>
          <p className="text-sm text-foreground-600 mt-2">按照喜好筛选，找到属于你的动漫世界</p>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-6 gap-4">
          {categories.map((cat) => (
            <div
              key={cat.id}
              className="group cursor-pointer bg-background-50 rounded-xl p-6 text-center hover:bg-primary-50/50 transition-all border border-background-200/70 hover:border-primary-200/70"
              onClick={() => handleClick(cat.slug)}
            >
              <div className="w-14 h-14 mx-auto mb-3 flex items-center justify-center rounded-full bg-accent-100 text-accent-500 group-hover:bg-primary-100 group-hover:text-primary-500 transition-all md:w-16 md:h-16">
                <i className={`${cat.icon} text-2xl`}></i>
              </div>
              <h3 className="text-sm font-medium text-foreground-950 group-hover:text-primary-600 transition-colors whitespace-nowrap">
                {cat.name}
              </h3>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}